module.exports = __webpack_public_path__ + "img/knu2_gallery17.46bf53a4.jpg";